<template>
    <div class="ath-lazy pr" style="min-width: 1px;min-height: 1px">
        <slot v-if="is_intersected"></slot>
    </div>
</template>

<script lang="ts">
interface ComponentData {
    is_intersected: boolean;
    observer: IntersectionObserver | null;
}

export default {
    name: 'mead-lazy',
    data(): ComponentData {
        return {
            is_intersected: false,
            observer: null,
        };
    },
    methods: {
        observe(): void {
            this.observer = new IntersectionObserver(
                this.onIntersection,
                {
                    root: undefined,
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0,
                }
            );
            this.observer?.observe(this.$el);
        },
        unobserve(): void {
            if (!this.observer) return;
            this.observer.unobserve(this.$el);
            this.observer = null;
        },
        onIntersection(entries: IntersectionObserverEntry[]): void {
            if (!entries || !entries[0]) return;
            this.is_intersected = entries[0].isIntersecting;
            if (this.is_intersected) this.unobserve();
        },
    },
    mounted(): void {
        this.observe();
    },
    beforeDestroy(): void {
        this.unobserve();
    },
};
</script>
